import { render, staticRenderFns } from "./descriptive.vue?vue&type=template&id=2e773558&scoped=true"
import script from "./descriptive.vue?vue&type=script&lang=js"
export * from "./descriptive.vue?vue&type=script&lang=js"
import style0 from "./descriptive.vue?vue&type=style&index=0&id=2e773558&prod&lang=scss"
import style1 from "./descriptive.vue?vue&type=style&index=1&id=2e773558&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e773558",
  null
  
)

export default component.exports